import { lbBrand } from '@fuse/colors';
import AppBar from '@material-ui/core/AppBar';
import { ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

function FooterLayout1() {
  const isScannerMatch = useRouteMatch(routesUrl.scanner);
  const footerTheme = useSelector(selectFooterTheme);
  const { t } = useTranslation();

  if (isScannerMatch) {
    return null;
  }

  return (
    <ThemeProvider theme={footerTheme}>
      <AppBar
        id="fuse-footer"
        className="relative z-10"
        color="default"
        style={{ backgroundColor: footerTheme.palette.background.paper }}
        elevation={2}
      >
        <Toolbar className="px-12 py-0 flex items-center">
          <div className="flex flex-1">
            {/* <PurchaseButton className="mx-4" /> */}
            <span className="hidden md:block">{t('components.footer.help')}&nbsp;</span>
            <span className="block md:hidden">{t('components.footer.helpMobile')}&nbsp;</span>
            <span>
              <a href="mailto:contact@littlebill.eu?subject=I need help!!!" style={{ color: lbBrand.red }}>
                contact@littlebill.eu
              </a>
            </span>
          </div>

          <div className="px-12">
            <span>LittleBill SAS</span>
          </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}

export default React.memo(FooterLayout1);
